export { fakeData } from './fakeData';
export { fakeLayers, fakeState } from './fakeLayers';
export { fakeAnimationList } from './fakeAnimationList';
export { fakeUser } from './fakeUsers';
export { fakeCombinedRaw } from './fakeCombined';

export const debugMode = false;
export const mockMode = false;
